import { Box, Button, Flex } from '@chakra-ui/react';

import { IRiskAction, RiskMessage } from './types';
import { RiskIcon } from './RiskIcon';

interface IRiskAlertMessage {
  message: RiskMessage;
  status?: 'info' | 'warning';
  hasAction?: boolean;
}

export const RiskAlert = (props: IRiskAction) => {
  const { id, isCheckedOff, canCheckOff, onCheckOffRisk, isDoc, isDocumentFixed, boxProps } = props;

  const getMessageProps = (): IRiskAlertMessage => {
    if (isCheckedOff) {
      return {
        status: 'info',
        message: RiskMessage.ACKNOWLEDGED,
        hasAction: false,
      };
    }

    if (isDoc) {
      if (isDocumentFixed) {
        return {
          status: 'info',
          message: RiskMessage.REUPLOADED,
          hasAction: false,
        };
      }
      return {
        status: 'warning',
        message: RiskMessage.ACTIONREQUIRED,
        hasAction: true,
      };
    }

    return {
      status: 'warning',
      message: RiskMessage.RISK,
      hasAction: true,
    };
  };

  const { message, hasAction } = getMessageProps();

  return (
    <Flex
      data-selector={`${id}-check-off-risk-container`}
      bgColor={'chakra-subtle-bg'}
      lineHeight={5}
      borderRadius={'lg'}
      gap={3}
      py={3}
      px={4}
      my={3}
      {...boxProps}
    >
      <Box fontSize={'lg'} lineHeight={5}>
        <RiskIcon {...props} />
      </Box>

      <Box>
        {message}

        {hasAction && canCheckOff ? (
          <Box>
            <Button
              data-selector={`${id}-check-off-risk-btn`}
              mt={2}
              onClick={!isCheckedOff && canCheckOff ? onCheckOffRisk : undefined}
            >
              Mark as OK
            </Button>
          </Box>
        ) : null}
      </Box>
    </Flex>
  );
};
